import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DonationStep from '../components/DonationStep';
import RequestFormStep from '../components/RequestFormStep';
import '../Style/DonationFlow.css';

const stripePromise = loadStripe(
  'pk_test_51TEY5QR8oSShaH4ZwXJzTWgbltKjRWyYElYGlrliXQ618er9Ic2SDc6xfxMBqdlKbvdW3FtzJrvv8vadRuoOnPNC00TnFiCdDt',
);

const DonationFlow = () => {
  const [step, setStep] = useState(1);
  const [paymentData, setPaymentData] = useState(null); // { paymentIntentId, amount }

  const handlePaymentSuccess = (data) => {
    setPaymentData(data);
    setStep(2);
  };

  return (
    <div className="donation-flow-container">
      <div className="donation-flow-card">
        {/* Step indicator */}
        <div className="step-indicator">
          <div className={`step-dot ${step >= 1 ? 'active' : ''}`}>1</div>
          <div className={`step-line ${step >= 2 ? 'active' : ''}`} />
          <div className={`step-dot ${step >= 2 ? 'active' : ''}`}>2</div>
        </div>

        {step === 1 && (
          <Elements stripe={stripePromise}>
            <DonationStep onSuccess={handlePaymentSuccess} />
          </Elements>
        )}

        {step === 2 && paymentData && <RequestFormStep paymentData={paymentData} />}
      </div>
    </div>
  );
};

export default DonationFlow;
